/**
 * Custom compose utility to replace Redux compose
 * Composes single-argument functions from right to left
 */
export function compose<A>(...funcs: Array<(a: A) => A>): (a: A) => A;
export function compose<A, B>(...funcs: Array<(a: any) => any>): (a: A) => B;
export function compose(...funcs: Array<(a: any) => any>): (a: any) => any {
    if (funcs.length === 0) {
        return (arg: any) => arg;
    }

    if (funcs.length === 1) {
        return funcs[0];
    }

    return funcs.reduce(
        (a, b) =>
            (...args: any[]) =>
                a(b(...args))
    );
}

export default compose;
